/* FNDRY — footer
   Mobile accordions + back to top.
   Panels ship OPEN from Liquid; this script closes them on mobile. If the
   script never runs, every link stays reachable. */
(function () {
  'use strict';

  function Footer(root) {
    this.root = root;
    this.cols = Array.prototype.slice.call(root.querySelectorAll('[data-ftr-col]'));
    /* Negate the query the stylesheet uses — never invent its complement.
       (max-width: 749px) is not the complement of (min-width: 750px): at
       749.5px both are false and JS would disagree with the CSS. */
    this.mq = window.matchMedia('(min-width: 750px)');
    this.bind();
    this.sync();
  }

  Footer.prototype.isMobile = function () { return !this.mq.matches; };

  Footer.prototype.bind = function () {
    var self = this;

    this.cols.forEach(function (col) {
      var btn = col.querySelector('[data-ftr-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (!self.isMobile()) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        self.setCol(col, !open);
      });
    });

    var onChange = function () { self.sync(); };
    if (this.mq.addEventListener) this.mq.addEventListener('change', onChange);
    else if (this.mq.addListener) this.mq.addListener(onChange);

    var totop = this.root.querySelector('[data-ftr-totop]');
    if (totop) {
      totop.addEventListener('click', function () {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      });
    }
  };

  Footer.prototype.setCol = function (col, open) {
    var btn = col.querySelector('[data-ftr-toggle]');
    col.setAttribute('data-collapsed', open ? 'false' : 'true');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  /* Desktop: everything open and the trigger is inert (CSS also forces the
     panel open there, so a stale attribute can never hide a column). */
  Footer.prototype.sync = function () {
    var mobile = this.isMobile();
    this.cols.forEach(function (col) {
      var btn = col.querySelector('[data-ftr-toggle]');
      if (!btn) return;
      if (!mobile) {
        col.setAttribute('data-collapsed', 'false');
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('tabindex', '-1');
        return;
      }
      btn.removeAttribute('tabindex');
      var startOpen = col.getAttribute('data-open-on-mobile') === 'true';
      this.setCol(col, startOpen);
    }, this);
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-fndry-footer]').forEach(function (el) {
      if (el.dataset.ftrReady === 'true') return;
      el.dataset.ftrReady = 'true';
      try {
        new Footer(el);
      } catch (err) {
        /* Leave every panel open rather than half-initialised. */
        el.querySelectorAll('[data-ftr-col]').forEach(function (col) {
          col.setAttribute('data-collapsed', 'false');
          var btn = col.querySelector('[data-ftr-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'true');
        });
        if (window.console) console.error('[fndry-footer]', err);
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();